import React from 'react'
import './basic-score-table.css'
import { Table } from 'reactstrap'


const BasicScoreTable = props => {
    const data = props.data.listData
    return (
        <div className='basic-score-table-container'>
            <div className='basic-score-table'>
                <Table className='table-change-color basic-striped'>
                    <thead>
                        <tr>
                            <th>Posição</th>
                            <th>Score</th>
                            <th>Nome</th>
                            <th>Grupo</th>
                        </tr>
                    </thead>
                    <tbody className=''>
                        {data.map((d, i) => {
                            return (
                                <tr className='tr-table-change-color' key={i}>
                                    <td>{d.posicao}</td>
                                    <td>{d.totalScore}</td>
                                    <td>{d.driverName}</td>
                                    <td>{d.groupName}</td>
                                </tr>

                            )
                        })}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default BasicScoreTable